<template>
  <div id="app">
    <router-view id="app-side" class="app-item box-shadow" name="side" />
    <div id="app-body" class="app-item">
      <!-- <div id="app-body-container" class="box-radius box-shadow"> -->
        <MainTitle />
        <div id="app-body-main">
          <router-view />
        </div>
      <!-- </div> -->
    </div>
    <Loading />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import MainTitle from './components/MainTitle'
import Loading from './components/Loading'
import { browserIsSupported } from './libs/util'

async function modalResolve (resolve, loading) {
  if (!loading) resolve()
  else {
    try {
      await resolve()
    } catch (error) {
      throw error
    } finally {
      this.$Modal.remove()
    }
  }
}

export default {
  components: { MainTitle, Loading },
  methods: {
    ...mapActions([ 'getExaminationStatus' ]),

    initToast () {
      window.toast = {
        info: msg => { this.$Message.info(msg) },
        success: msg => { this.$Message.success(msg) },
        error: msg => { this.$Message.error(msg) },
        warning: msg => { this.$Message.warning(msg) }
      }
    },
    initAlert () {
      window.alert = ({
        type = 'info',
        title = '提示',
        content,
        loading = false,
        okText
      }) => {
        return new Promise(resolve => {
          this.$Modal[type]({
            title,
            content,
            loading,
            okText,
            onOk: () => { modalResolve.bind(this)(() => resolve(), loading) }
          })
        })
      }
    },
    initConfirm () {
      window.confirm = ({
        title = '请确认',
        content,
        loading = false
      }) => {
        return new Promise(resolve => {
          this.$Modal.confirm({
            title,
            content,
            loading,
            onOk: () => { modalResolve.bind(this)(() => resolve(true), loading) },
            onCancel: () => { modalResolve.bind(this)(() => resolve(false), loading) }
          })
        })
      }
    },
    browserTest () {
      if (!browserIsSupported()) {
        alert({
          type: 'warning',
          title: '浏览器可用性提示！',
          content: `
            <p>当前浏览器可能导致本网站部分功能不可用，为了您能够正常进行考试等操作，建议使用下载并使用以下浏览器的最新版本：</p>
            <p class="text-theme text-bold margin-top-10px margin-bottom-10px">谷歌浏览器、火狐浏览器、QQ浏览器、Safari浏览器</p>
            <p>如您继续使用当前浏览器，导致的所有错误将有您自己承担！</p>
          `,
          okText: '我知道了'
        })
      }
    }
  },
  created () {
    this.getExaminationStatus()
    this.initToast()
    this.initAlert()
    this.initConfirm()
    this.browserTest()
  }
}
</script>

<style lang="less" >
#app {
  display: flex;
  min-width: 1200px;
  
  .app-item {
    position: relative;
  }
  &-body {
    flex: 1;
    padding: 20px;

    &-container {
      height: calc(100vh - 40px);
      background: #ffffff;
      overflow-y: auto;
    }
    &-main {
      padding: 10px;
    }
  }
  &-side {
    flex: none;
    z-index: 1;
  }
  
}
</style>


